module.exports = __webpack_public_path__ + "img/mais-acoes.163fc41c.svg";